import {
  fetchLastReadMessageIndex,
  lastReadMessageQueryKey,
  markAllAsRead,
  markIndexAsRead,
} from 'app/services/twilio/lastReadMessageIndex';
import { useQuery } from '@tanstack/react-query';

export default function useLastReadMessageIndex() {
  const { data } = useQuery<number>({
    queryKey: lastReadMessageQueryKey,
    queryFn: fetchLastReadMessageIndex,
  });

  return {
    lastReadMessageIndex: data ?? 0,
    markAllAsRead,
    markIndexAsRead,
    ready: !!data,
  };
}
